export default __webpack_public_path__ + "static/media/etfdetails_screenshot.7682e6dc.png";